/**
 * Checks if two users match based on their email/username and login provider.
 * Handles special case where email login can match with Google login if emails are the same.
 */
export function isMatchingUsers(currentUser, expectedUser) {
    const isMatchingUser = expectedUser.email
        ? currentUser.email === expectedUser.email
        : currentUser.username === expectedUser.username;
    const isMatchingProvider = currentUser.loginProvider === expectedUser.loginProvider ||
        (currentUser.loginProvider === 'email' &&
            (expectedUser.loginProvider === 'google' || expectedUser.loginProvider === 'x') &&
            expectedUser.email === currentUser.email);
    return isMatchingUser && isMatchingProvider;
}
//# sourceMappingURL=UserMatching.js.map